import { defineMessages } from 'react-intl';

export const productVariationMessages = defineMessages({
  slotTitle: {
    id: 'detailview.grid.headline.details',
    defaultMessage: 'Produktdetails und Serviceinfos',
  },
  expandCardText: {
    id: 'collapsibleCard.expand.text',
    defaultMessage: 'Mehr Produkteigenschaften anzeigen',
  },
  collapseCardText: {
    id: 'collapsibleCard.collapse.text',
    defaultMessage: 'Weniger Produkteigenschaften anzeigen',
  },
  collapsibleCardHeader: {
    id: 'collapsibleCard.header',
    defaultMessage: 'Artikelbeschreibung',
  },
});

export const bypassBlockMessages = defineMessages({
  bypassImageGallery: {
    id: 'detailview.imageGallery.bypass.headline.text',
    defaultMessage: 'Produktbilder Galerie überspringen',
  },
  bypassRecommendations: {
    id: 'detailview.recommendations.bypass.headline.text',
    defaultMessage: 'Empfohlene Produkte überspringen',
  },
  bypassDetailsAndInfo: {
    id: 'detailview.detailsAndInfo.bypass.headline.text',
    defaultMessage: 'Informationen über das Produkt überspringen',
  },
  bypassCustomerRatings: {
    id: 'detailview.customerRatings.bypass.headline.text',
    defaultMessage: 'Kundenbewertungen über das Produkt überspringen',
  },
  bypassSeoList: {
    id: 'detailview.seoList.bypass.headline.text',
    defaultMessage: 'Empfohlene Kategorien überspringen',
  },
});
